import React from 'react';

import MainBlock from '../../shared/web/layout/MainBlock';
import TextField from '../../shared/uibuilder/show/field/TextField';
import ProjectPagesButtons from '../view/ProjectPagesButtons';
import { ProjectTypeField } from 'features/tasks-forms';
import { useProjectId } from 'features/nekst-widgets';
import ProjectNotesList from './ProjectNotesList';

export default function ShadcnProjectDetails() {
  const projectId = useProjectId();

  return (
    <MainBlock
      title={<TextField source="name" />}
      titleLine2={<ProjectTypeField />}
      headerRight={(
        <ProjectPagesButtons />
      )}
      columnContent={(
        <ProjectNotesList projectId={projectId} />
      )}
    >
      <div />
    </MainBlock>
  );
}
